<!-- The actual video element responsible for file playback -->
<video #media class="video" width="100%" height="100%" preload="auto"></video>

<!-- If Video has no Controls and interaction is enabled, we need to add our own trigger -->
@if (mediaRepository.displayUIControlZone()) {
  <div class="ui-trigger" (pointerup)="controlZonePointerUp()"></div>
}
